import { EMailType } from '@leedpulse-monorepo/enums';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface SendMailResponse {
  success: boolean;
  message: string;
}

async function sendMail(
  mailType: EMailType,
  userId: string,
  auth: Authentication | null,
): Promise<SendMailResponse> {
  try {
    if (!auth) throw new SendMailFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(
      `/backoffice/users/${userId}/sendmail`,
      { mailType },
      auth.token
    );

    return response;
  } catch (e) {
    if (e instanceof SendMailFailure) throw e;
    // HttpClient throws plain Error; preserve message so the UI can show it
    const errMessage =
      e instanceof Error
        ? e.message
        : typeof e === 'string'
          ? e
          : 'Une erreur inattendue s’est produite.';
    throw new SendMailFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class SendMailFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default sendMail;
